const NAVY = '#112244'
const INK = '#1d2433'
const MUTED = '#6b7385'
const BORDER = '#e3e6ec'
const FONT = 'Archivo, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'

const svg = (path, fill) => `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="${fill}" d="${path}"/></svg>`

const ICON_ARROW_UP = 'M13,20H11V8L5.5,13.5L4.08,12.08L12,4.16L19.92,12.08L18.5,13.5L13,8V20Z'
const ICON_PAPERCLIP = 'M16.5,6V17.5A4,4 0 0,1 12.5,21.5A4,4 0 0,1 8.5,17.5V5A2.5,2.5 0 0,1 11,2.5A2.5,2.5 0 0,1 13.5,5V15.5A1,1 0 0,1 12.5,16.5A1,1 0 0,1 11.5,15.5V6H10V15.5A2.5,2.5 0 0,0 12.5,18A2.5,2.5 0 0,0 15,15.5V5A4,4 0 0,0 11,1A4,4 0 0,0 7,5V17.5A5.5,5.5 0 0,0 12.5,23A5.5,5.5 0 0,0 18,17.5V6H16.5Z'
const ICON_STOP = 'M8,7H16A1,1 0 0,1 17,8V16A1,1 0 0,1 16,17H8A1,1 0 0,1 7,16V8A1,1 0 0,1 8,7Z'

const BUTTON_SIZE = '28px'
const ICON_SIZE = { height: '16px', width: '16px' }

const inputButton = (background, extra = {}) => ({
  alignItems: 'center',
  backgroundColor: background,
  borderRadius: '8px',
  boxSizing: 'border-box',
  display: 'flex',
  height: BUTTON_SIZE,
  justifyContent: 'center',
  padding: '0',
  width: BUTTON_SIZE,
  ...extra
})

export const MAX_FILES_PER_MESSAGE = 5

export const buildStopButton = (onClick) => ({
  initialState: 'disabled',
  onClick,
  position: 'inside-end',
  styles: {
    button: {
      default: {
        container: { default: inputButton('#ffffff', { border: '1px solid #d5d9e2' }), hover: { backgroundColor: '#f3f5f8' } },
        svg: { content: svg(ICON_STOP, NAVY), styles: { default: ICON_SIZE } }
      },
      disabled: {
        container: { default: { display: 'none' } }
      }
    }
  },
  tooltip: { text: 'Stop the agent' }
})

export const buildChatConfig = ({ placeholder }) => ({
  auxiliaryStyle: CHAT_CSS,
  chatStyle: {
    backgroundColor: 'transparent',
    border: 'none',
    fontFamily: FONT,
    fontSize: '1rem',
    height: '100%',
    width: '100%'
  },
  dragAndDrop: {
    backgroundColor: 'rgba(17, 34, 68, 0.05)',
    border: '2px dashed rgba(17, 34, 68, 0.28)',
    borderRadius: '12px'
  },
  inputAreaStyle: {
    backgroundColor: 'transparent',
    borderTop: 'none',
    boxSizing: 'border-box',
    padding: '4px 12px 12px'
  },
  messageStyles: {
    default: {
      ai: {
        bubble: { backgroundColor: 'transparent', color: INK, maxWidth: '100%', padding: '2px 0', width: '100%' }
      },
      shared: {
        bubble: { borderRadius: '12px', fontSize: '1rem', lineHeight: '1.6', marginTop: '6px', padding: '8px 12px' },
        outerContainer: { padding: '0 12px' }
      },
      user: {
        bubble: { backgroundColor: '#eef0f4', color: NAVY, maxWidth: '85%' }
      }
    },
    file: {
      shared: { bubble: { backgroundColor: '#f5f6f8', border: `1px solid ${BORDER}`, borderRadius: '10px', color: NAVY, fontSize: '0.92rem', padding: '6px 10px' } }
    },
    html: {
      shared: { bubble: { backgroundColor: 'transparent', maxWidth: '100%', padding: '0', width: '100%' } }
    },
    image: {
      shared: { bubble: { maxWidth: '60%', padding: '0' } }
    },
    intro: { backgroundColor: 'transparent', color: MUTED, fontSize: '1rem', padding: '4px 0' },
    error: { backgroundColor: '#fde8e1', borderRadius: '10px', color: '#a23b17', fontSize: '1rem' }
  },
  mixedFiles: {
    button: {
      position: 'inside-start',
      styles: {
        container: { default: inputButton('transparent'), hover: { backgroundColor: '#eef0f4' } },
        svg: { content: svg(ICON_PAPERCLIP, MUTED), styles: { default: ICON_SIZE } }
      },
      tooltip: { text: 'Attach files' }
    },
    files: {
      maxNumberOfFiles: MAX_FILES_PER_MESSAGE
    }
  },
  scrollButton: {
    styles: {
      default: { backgroundColor: '#ffffff', border: `1px solid ${BORDER}`, boxShadow: '0 4px 12px rgba(17, 34, 68, 0.12)' }
    }
  },
  submitButtonStyles: {
    alwaysEnabled: false,
    disabled: {
      container: { default: inputButton('#e3e6ec') },
      svg: { content: svg(ICON_ARROW_UP, '#9aa3b5'), styles: { default: ICON_SIZE } }
    },
    position: 'inside-end',
    submit: {
      container: { default: inputButton(NAVY), hover: { backgroundColor: '#1c3160' } },
      svg: { content: svg(ICON_ARROW_UP, '#ffffff'), styles: { default: ICON_SIZE } }
    }
  },
  textInput: {
    placeholder: { style: { color: '#8a93a6' }, text: placeholder },
    styles: {
      container: {
        backgroundColor: '#ffffff',
        border: '1px solid rgba(17, 34, 68, 0.16)',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(17, 34, 68, 0.05)',
        boxSizing: 'border-box',
        margin: '0',
        width: '100%'
      },
      focus: { border: '1px solid rgba(17, 34, 68, 0.4)' },
      text: { color: NAVY, fontFamily: FONT, fontSize: '1rem', lineHeight: '1.5' }
    }
  }
})

const CHAT_CSS = `
  #input { align-items: stretch; }
  #messages { overflow-x: hidden; }
  #text-input-container { min-height: 44px; }
  .inner-button-container { align-self: stretch; }
  .text-input-inner-start-adjustment { padding: 12px 42px !important; }
  .text-input-inner-end-adjustment { padding-right: 42px !important; }
  #input:has(.custom-button-container-default) .text-input-inner-end-adjustment { padding-right: 76px !important; }
  .input-button.inside-start { bottom: 6px !important; left: 8px !important; right: auto !important; top: auto !important; }
  .input-button.inside-end { bottom: 6px !important; left: auto !important; right: 8px !important; top: auto !important; }
  .custom-button.inside-end { right: 42px !important; }
  #file-attachment-container { background: #ffffff !important; border: 1px solid ${BORDER}; border-radius: 10px; bottom: calc(100% - 2px) !important; box-shadow: 0 4px 12px rgba(17, 34, 68, 0.08); display: flex !important; flex-wrap: wrap; gap: 6px; height: auto !important; left: 12px !important; max-height: 96px; overflow-y: auto; padding: 6px !important; right: 12px; top: auto !important; width: auto !important; }
  #file-attachment-container:not(:has(.file-attachment)) { display: none !important; }
  .file-attachment { height: 28px !important; margin: 0 !important; width: auto !important; }
  .border-bound-attachment { align-items: center; background: #f5f6f8; border: 1px solid ${BORDER} !important; border-radius: 8px !important; box-sizing: border-box; display: flex; height: 28px !important; padding: 0 26px 0 10px; width: auto !important; }
  .file-attachment-text-container { height: auto !important; position: static !important; width: auto !important; }
  .any-file-attachment-text { color: ${NAVY}; font-family: ${FONT}; font-size: 0.9rem; max-width: 180px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: auto !important; }
  .file-attachment img { border-radius: 6px; height: 26px !important; width: auto !important; }
  .remove-file-attachment-button { left: auto !important; right: 6px; top: 6px !important; }
  .text-message img { border-radius: 10px; display: block; height: auto; margin: 6px 0; max-height: 420px; max-width: 100%; object-fit: contain; }
  .text-message a { color: ${NAVY}; text-decoration: underline; text-underline-offset: 2px; }
  .text-message p { margin: 0 0 10px; }
  .text-message p:last-child { margin-bottom: 0; }
  .text-message ul, .text-message ol { margin: 4px 0 10px; padding-left: 22px; }
  .text-message li { margin: 3px 0; }
  .text-message h1, .text-message h2, .text-message h3 { color: ${NAVY}; line-height: 1.3; margin: 14px 0 6px; }
  .text-message h1 { font-size: 1.3rem; } .text-message h2 { font-size: 1.15rem; } .text-message h3 { font-size: 1.05rem; }
  .text-message code { background: #f1f3f7; border-radius: 6px; font-size: 0.85em; padding: 1px 5px; }
  .text-message pre { background: #0f1b33; border-radius: 12px; color: #e7ebf3; overflow-x: auto; padding: 12px 14px; }
  .text-message pre code { background: transparent; color: inherit; padding: 0; }
  .text-message table { border-collapse: collapse; display: block; font-size: 0.95rem; margin: 8px 0; max-width: 100%; overflow-x: auto; }
  .text-message th, .text-message td { border: 1px solid ${BORDER}; padding: 6px 10px; text-align: left; }
  .text-message th { background: #f5f6f8; font-weight: 600; }
  .text-message blockquote { border-left: 3px solid #e8d121; color: ${MUTED}; margin: 8px 0; padding-left: 12px; }

  .cg-icon { border-radius: 50%; box-sizing: border-box; display: inline-block; flex: none; height: 16px; margin-top: 2px; position: relative; width: 16px; }
  .cg-icon--running { animation: cg-spin 0.8s linear infinite; border: 2px solid #d5d9e2; border-top-color: ${NAVY}; }
  .cg-icon--success, .cg-icon--done { background: #e6f4ea; }
  .cg-icon--success::after, .cg-icon--done::after { border: solid #2e7d32; border-width: 0 2px 2px 0; content: ''; height: 7px; left: 5px; position: absolute; top: 2px; transform: rotate(45deg); width: 4px; }
  .cg-icon--error { background: #fde8e1; }
  .cg-icon--error::after { color: #d8471a; content: '!'; font-size: 11px; font-weight: 700; left: 0; line-height: 16px; position: absolute; right: 0; text-align: center; top: 0; }
  .cg-icon--stopped { background: #eef0f4; }
  .cg-icon--stopped::after { background: ${MUTED}; border-radius: 1px; content: ''; height: 6px; left: 5px; position: absolute; top: 5px; width: 6px; }
  @keyframes cg-spin { to { transform: rotate(360deg); } }

  .cg-activity { background: #fafbfc; border: 1px solid ${BORDER}; border-radius: 14px; color: ${INK}; font-family: ${FONT}; font-size: 0.95rem; margin: 2px 0; overflow: hidden; }
  .cg-activity-toggle { align-items: center; cursor: pointer; display: flex; gap: 10px; list-style: none; padding: 10px 12px; user-select: none; }
  .cg-activity-toggle::-webkit-details-marker { display: none; }
  .cg-activity-toggle:hover { background: #f3f5f8; }
  .cg-activity--empty { background: transparent; border-color: transparent; }
  .cg-activity--empty .cg-activity-toggle { cursor: default; padding: 6px 2px; }
  .cg-activity--empty .cg-activity-toggle:hover { background: transparent; }
  .cg-activity--empty .cg-activity-title { color: ${MUTED}; font-weight: 500; }
  .cg-activity-toggle .cg-icon { margin-top: 0; }
  .cg-activity-title { align-items: baseline; display: flex; flex: 1; font-weight: 600; gap: 8px; min-width: 0; }
  .cg-activity-meta { color: ${MUTED}; font-weight: 400; white-space: nowrap; }
  .cg-chevron { border: solid ${MUTED}; border-width: 0 1.5px 1.5px 0; height: 6px; margin-right: 4px; transform: rotate(45deg); transition: transform 0.15s ease; width: 6px; }
  .cg-activity[open] .cg-chevron { transform: rotate(-135deg); }
  .cg-steps { border-top: 1px solid #eef0f3; padding: 6px 12px 10px; }
  .cg-step { display: flex; gap: 10px; padding: 5px 0; }
  .cg-step-body { min-width: 0; }
  .cg-step-title { color: ${INK}; font-weight: 500; }
  .cg-step-meta { color: ${MUTED}; font-weight: 400; margin-left: 8px; }
  .cg-step-detail { color: ${MUTED}; font-size: 0.88rem; margin-top: 1px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .cg-step--error .cg-step-detail { color: #b53d14; white-space: normal; }

  .cg-agent { background: #ffffff; border: 1px solid ${BORDER}; border-left: 3px solid #e8d121; border-radius: 10px; margin: 6px 0; padding: 8px 10px; }
  .cg-agent-head { align-items: center; display: flex; flex-wrap: wrap; gap: 2px 8px; }
  .cg-agent-type, .cg-step-meta, .cg-activity-meta { white-space: nowrap; }
  .cg-agent-head .cg-step-meta { margin-left: auto; }
  .cg-agent-head .cg-icon { margin-top: 0; }
  .cg-agent-label { color: ${NAVY}; font-size: 0.78rem; font-weight: 700; letter-spacing: 0.06em; text-transform: uppercase; }
  .cg-agent-type { background: #fbf6d0; border-radius: 999px; color: #6d5f00; font-size: 0.8rem; font-weight: 600; padding: 1px 8px; }
  .cg-agent-title { color: ${INK}; font-weight: 600; margin: 4px 0 2px 24px; }
  .cg-agent-steps { border-left: 1px dashed #d5d9e2; margin: 4px 0 0 7px; padding-left: 16px; }
  .cg-agent-thought { color: ${MUTED}; font-style: italic; margin: 4px 0 0 24px; }
  .cg-agent-result { background: #f5f6f8; border-radius: 8px; color: ${INK}; margin: 6px 0 0 24px; padding: 6px 10px; }

  .cg-shimmer { animation: cg-shimmer 1.6s linear infinite; background: linear-gradient(90deg, ${NAVY} 0%, #8a93a6 50%, ${NAVY} 100%); background-clip: text; background-size: 200% 100%; color: transparent; -webkit-background-clip: text; }
  @keyframes cg-shimmer { to { background-position: -200% 0; } }

  .cg-question { background: #ffffff; border: 1px solid rgba(17, 34, 68, 0.16); border-radius: 16px; box-shadow: 0 8px 22px rgba(17, 34, 68, 0.08); color: ${INK}; font-family: ${FONT}; margin: 4px 0; padding: 14px; }
  .cg-q-title { align-items: center; color: ${NAVY}; display: flex; font-size: 0.85rem; font-weight: 700; gap: 8px; letter-spacing: 0.04em; margin-bottom: 10px; text-transform: uppercase; }
  .cg-q-badge { background: #e8d121; border-radius: 50%; box-shadow: 0 0 0 4px rgba(232, 209, 33, 0.25); height: 8px; width: 8px; }
  .cg-question--pending .cg-q-badge { animation: cg-pulse 1.4s ease-in-out infinite; }
  .cg-question--answered .cg-q-badge, .cg-question--cancelled .cg-q-badge { background: #b8bfcc; box-shadow: none; }
  @keyframes cg-pulse { 50% { box-shadow: 0 0 0 7px rgba(232, 209, 33, 0.08); } }
  .cg-q-block + .cg-q-block { border-top: 1px solid #eef0f3; margin-top: 12px; padding-top: 12px; }
  .cg-q-header { background: #eef0f4; border-radius: 999px; color: ${NAVY}; font-size: 0.8rem; font-weight: 600; padding: 2px 8px; }
  .cg-q-hint { color: ${MUTED}; font-size: 0.85rem; margin-left: 8px; }
  .cg-q-text { font-size: 1.05rem; font-weight: 600; line-height: 1.4; margin: 8px 0 10px; }
  .cg-q-options { display: grid; gap: 8px; }
  .cg-q-option { align-items: flex-start; background: #ffffff; border: 1px solid ${BORDER}; border-radius: 12px; color: ${INK}; cursor: pointer; display: flex; font-family: ${FONT}; font-size: 1rem; gap: 10px; padding: 10px 12px; text-align: left; transition: border-color 0.12s ease, background 0.12s ease; width: 100%; }
  .cg-q-option:hover:not([disabled]) { background: #f7f8fa; border-color: rgba(17, 34, 68, 0.45); }
  .cg-q-option[disabled] { cursor: default; opacity: 0.55; }
  .cg-q-option--selected, .cg-q-option--selected[disabled] { background: #f1f4fa; border-color: ${NAVY}; opacity: 1; }
  .cg-q-check { border: 1.5px solid #b8bfcc; border-radius: 50%; flex: none; height: 16px; margin-top: 1px; position: relative; width: 16px; }
  .cg-q-option--selected .cg-q-check { background: ${NAVY}; border-color: ${NAVY}; }
  .cg-q-option--selected .cg-q-check::after { border: solid #ffffff; border-width: 0 2px 2px 0; content: ''; height: 7px; left: 5px; position: absolute; top: 2px; transform: rotate(45deg); width: 3px; }
  .cg-q-option-text { display: flex; flex-direction: column; gap: 2px; pointer-events: none; }
  .cg-q-check { pointer-events: none; }
  .cg-q-option-label { font-weight: 600; }
  .cg-q-option-desc { color: ${MUTED}; font-size: 0.9rem; line-height: 1.4; }
  .cg-q-custom { background: #f1f4fa; border-radius: 10px; color: ${NAVY}; font-weight: 500; margin-top: 8px; padding: 8px 12px; }
  .cg-q-footer { align-items: center; display: flex; gap: 12px; justify-content: space-between; margin-top: 12px; }
  .cg-q-status { color: ${MUTED}; font-size: 0.9rem; }
  .cg-q-submit { background: ${NAVY}; border: none; border-radius: 10px; color: #ffffff; cursor: pointer; font-family: ${FONT}; font-size: 0.95rem; font-weight: 600; padding: 7px 12px; }
  .cg-q-submit[disabled] { background: #c9ceda; cursor: default; }
`
